import { EPayoutTicketStatus } from '../../../types/enums'
import {
  ExternalTransaction,
  ExternalUser,
  TicketCashBox,
  TicketExecutor,
  TicketMerchant,
} from '../payment-tickets/core/_models'
import { ClientRequisite } from './core/_models'
import { CashBoxAttempt } from '../ticket-card/core/cashBoxAttempts.types'

export interface ITransaction {
  id?: number
  paymentId: string
  createdAt: string
  completedAt: string | null
  paymentAdapter: string
  cashbox: string | null
  requisiteName: string
  status: string
  adapterStatus?: string | null
  error: string
  errorRaw?: string
  /** Present only for roles that see cassa attempts; null on a row of another adapter. */
  cashBoxAttempts?: CashBoxAttempt[] | null
}

/**
 * CPAYMENT-1713: one channel of a payout. A composite payout method carries several — a card and an
 * SBP phone — and matching hands the depositor the one matching the deposit's own kind.
 */
export interface IPayoutRequisite {
  requisiteKind: string
  type: string
  identifier: string
  currency: string
  acquiringBank: string | null
  cardholder: string | null
}

export type TAutoHaltResolution = 'COMPLETE' | 'CASCADE' | 'LOCAL_ADAPTER'
export type TRemainderRoute = 'CASCADE_WITHOUT_MATCHING' | 'LOCAL_ADAPTER'

export const AUTO_HALT_RESOLUTION_LABELS: Record<TAutoHaltResolution, string> = {
  COMPLETE: 'Завершение выплаты',
  CASCADE: 'Отправлена в каскад',
  LOCAL_ADAPTER: 'Отправлена в локальный адаптер',
}

export interface IPayoutTicket {
  status: EPayoutTicketStatus
  merchant: TicketMerchant
  completionDate: string | null
  amount: number
  notifiedDate: string | null
  comment: string | null
  token: string
  callbackUrl: string | null
  createdAt: string
  externalUserId: number
  processType: string
  cashBox: TicketCashBox
  executor: TicketExecutor | null
  /** Primary channel. Kept for backward compatibility — prefer userRequisites. */
  externalUserRequisite?: ClientRequisite
  /** Every channel of the payout, primary first. Absent on responses that predate CPAYMENT-1713. */
  userRequisites?: IPayoutRequisite[]
  externalUser?: ExternalUser
  requestedAmount: number
  lastExternalTransaction: ExternalTransaction | null
  transactions?: ITransaction[]
  cascadeStopped: boolean
  /** Matching halted the payout on its profile timeout and this outcome was applied (staff only). */
  autoHaltResolution?: TAutoHaltResolution | null
  /** On a remainder sent on by that outcome: where it went instead of matching (staff only). */
  remainderRoute?: TRemainderRoute | null
  /** The remainder payout this one was recreated into. */
  recreatedTicketToken?: string | null
  /** The payout this one is the remainder of. */
  recreatedFromToken?: string | null
}
